import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=3e9d0048&scoped=true&"
import script from "./tab-bar.vue?vue&type=script&lang=js&"
export * from "./tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./tab-bar.vue?vue&type=style&index=0&id=3e9d0048&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9d0048",
  null
  
)

export default component.exports